import { Container, makeStyles, Theme, Typography } from '@material-ui/core';
import React, { ReactNode } from 'react';
import Board from './images/Board.svg';
import UndrawnDocument from './images/UndrawnDocument.svg';

import { useTranslation } from '@fluentsms/i18n';

export type DataGridNoDataBodyProps = {
  headerMessage?: ReactNode;
  variant?: 'default' | 'board' | 'undrawnDocument';
  actionMessage?: ReactNode;
  imgClassName?: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    flexDirection: 'column',
    padding: theme.spacing(6, 4),
  },
  imgContainer: {
    padding: theme.spacing(6.5),
  },
}));

export const BOARD = 'board';
export const UNDRAWN_DOCUMENT = 'undrawnDocument';

const imgMap: { [key: string]: string } = {
  [BOARD]: Board,
  [UNDRAWN_DOCUMENT]: UndrawnDocument,
};

export const DataGridNoDataBody = ({
  headerMessage,
  variant = BOARD,
  actionMessage,
  imgClassName,
}: DataGridNoDataBodyProps) => {
  const classes = useStyles();
  const { t } = useTranslation('common');

  if (!headerMessage) {
    headerMessage = t('dataGrid.noResults');
  }

  if (!actionMessage) {
    actionMessage = t('dataGrid.tryDifferentSearch');
  }

  return (
    <Container className={classes.root} data-testid="no-data-result-container">
      {typeof headerMessage == 'string' ? <Typography variant="h1">{headerMessage}</Typography> : headerMessage}
      <div className={classes.imgContainer}>
        <img src={imgMap[variant]} alt="no-data-img" data-testid="no-data-img" className={imgClassName} />
      </div>
      {typeof actionMessage == 'string' ? <Typography variant="h1">{actionMessage}</Typography> : actionMessage}
    </Container>
  );
};

export default DataGridNoDataBody;
